
export default function timeStamp() {
  return new Date().getTime()
}
